// extracted by css-extract-rspack-plugin
export default {"cls1":"CoScientistLandingPage-cls1_MBQ","cls2":"CoScientistLandingPage-cls2_Eeh CoScientistLandingPage-cls1_MBQ"};